import axios, { type AxiosRequestConfig } from 'axios'
import { ElMessage } from 'element-plus'
import router from '@/router'
import { useUserStore } from '@/stores'

// 自定义实例类型，返回值直接是 T 而不是 AxiosResponse<T>
interface CustomInstance {
  get<T = any>(url: string, config?: AxiosRequestConfig): Promise<T>
  post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T>
  put<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T>
  delete<T = any>(url: string, config?: AxiosRequestConfig): Promise<T>
}

const request = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000',
  timeout: 190000,
})

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    const userStore = useUserStore()
    if (userStore.token) {
      config.headers.Authorization = `Bearer ${userStore.token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 需要跳转登录的错误码
const LOGIN_REQUIRED_REASONS = [
  'ERR_TOKEN_EXPIRED',
  'ERR_TOKEN_IN_BLACKLIST',
  'ERR_USER_NOT_EXIST',
  'ERR_UPDATE_USER_MUST_LOGIN',
]

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    return response.data
  },
  (error) => {
    if (error.response) {
      const { status, data } = error.response
      const reason = data?.reason || ''
      const message = data?.message || ''
      
      // 处理 HTTP 标准错误
      switch (status) {
        case 401:
          ElMessage.error('未登录或登录已过期')
          {
            const userStore = useUserStore()
            userStore.logout()
            router.push('/login')
          }
          break
        case 403:
          ElMessage.error('没有权限')
          break
        case 404:
          ElMessage.error('请求的资源不存在')
          break
        case 500:
          ElMessage.error(message || '服务器错误')
          break
        case 450:
          // Kratos 业务错误处理
          if (LOGIN_REQUIRED_REASONS.includes(reason)) {
            ElMessage.error(message || '请重新登录')
            const userStore = useUserStore()
            userStore.logout()
            router.push('/login')
          } else {
            ElMessage.error(message || '操作失败')
          }
          break
        default:
          ElMessage.error(message || '请求失败')
      }
    } else {
      ElMessage.error('网络错误，请检查网络连接')
    }
    return Promise.reject(error)
  }
)

export default request as unknown as CustomInstance

